import { gql } from "graphql-tag"

import { DEFAULTS } from "../shared/utils/defaults"

const typeArticleMainGroup = gql`
  type ArticleMainGroup {
    id: ID!
    key: String
    name: String
  }

  type ArticleMainGroups {
    total: Int
    page: Int
    items: [ArticleMainGroup]
  }

  type Query {
    articleMainGroup(
      id: ID!
    ): ArticleMainGroup

    articleMainGroups(
      offset: Int = ${DEFAULTS.QUERY.OFFSET}
      limit: Int = ${DEFAULTS.QUERY.LIMIT}
      sort: Sort
      sortWithinLimits: Boolean = false
      cdn: Boolean = true
    ): ArticleMainGroups

}
`

export { typeArticleMainGroup }

export default typeArticleMainGroup
